// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1mqrO","inner":"Footer_inner__Y3n9W"};